import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useIsLearner } from "@domain/currentProfile/hooks";
import { useIsMobile } from "@utils/hooks";
import { Subtitle } from "@ui/components/containers/title";
import { row, Stack, stack } from "@ui/components/layout";
import { AssetManager } from "@ui/components/media/assetManager/assetManager";
import { UploadArea } from "@ui/components/media/uploadArea";
import { FileUpload } from "@ui/components/mediaEditor/fileUpload";
import { BackButton } from "@ui/components/navigation/backButton";
import { Page } from "@ui/components/page";
import { desktop, mobile } from "@ui/styles/utils";

export const AssetManagerPage: React.FC = () => {
	const isMobile = useIsMobile();
	const isLearner = useIsLearner();

	return (
		<Container header={I18n.t("asset_manager.title")} containerStyle={{ maxWidth: "100vw", margin: 0, padding: 0 }}>
			{isLearner && isMobile ? null : (
				<UploadContainer>
					{!isMobile && (
						<Stack gap={40}>
							<BackButton text={I18n.t("asset_manager.mine.title")} path={Path.MyProfile} />
							{isLearner ? null : <Subtitle>{I18n.t("asset_manager.upload.title")}</Subtitle>}
						</Stack>
					)}
					{isLearner ? null : (
						<FileUpload type="file" bigSize multiple>
							{(dragging, loading, progress) => (
								<UploadArea dragging={dragging} loading={loading} progress={progress} />
							)}
						</FileUpload>
					)}
				</UploadContainer>
			)}
			<StyledAssetManager />
		</Container>
	);
};

const Container = styled(Page)`
	@media ${desktop} {
		${row(0)};
	}
	@media ${mobile} {
		${stack(0, "flex-start", "stretch")};
	}
`;

const UploadContainer = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	padding: 82px 10px 10px;
	@media ${desktop} {
		${stack(45)};
		padding: 140px 80px;
		position: sticky;
		top: 0;
		left: 0;
		height: 100vh;
	}
`;

const StyledAssetManager = styled(AssetManager)`
	flex: 1;
	margin: 140px 80px 0 80px;
	@media ${mobile} {
		margin: 40px 16px;
	}
`;
